export const initialFilter = () => ({
  academicYear: null,
  center: null,
  municipality: null,
  school: null,
  category: null,
  name: null,
  grade: null,
});

export const initialCatalog = () => ({
  academicYears: [],
  centers: [],
  municipalities: [],
  schools: [],
  categories: [],
  names: [],
  grades: [],
});

export const initialPagination = () => ({
  count: 0,
  currentPage: 0,
  pageCount: 0,
  totalItemCount: 0,
});
